import React from 'react';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import { Button as PasswordResetButton } from '@material-ui/core';

// core components
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import CustomInput from 'components/CustomInput/CustomInput';
import Button from 'components/CustomButtons/Button';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import CardHeader from 'components/Card/CardHeader';
import CardFooter from 'components/Card/CardFooter';

import AuthService from 'services/auth.service';
import { verifyLength } from 'plugins/validation/validation-rules';
import { useHistory } from 'react-router-dom';
import { store } from 'plugins/store/store';
import { setAuthActionCreator } from 'plugins/store/reducers/auth.reducer';
import { setLockedActionCreator } from 'plugins/store/reducers/auth.reducer';
import { useSnackbar } from 'notistack';
import SnackMessage from 'components/Snackbar/SnackMessage';
import styles from 'assets/jss/material-dashboard-pro-react/views/loginPageStyle';
import layoutNames from 'utils/enums/layout-names.enum';

const useStyles = makeStyles(styles);

export default function LoginPage(props) {
	const [cardAnimaton, setCardAnimation] = React.useState('cardHidden');
	React.useEffect(() => {
		let id = setTimeout(function () {
			setCardAnimation('');
		}, 700);
		// Specify how to clean up after this effect:
		return function cleanup() {
			window.clearTimeout(id);
		};
	});

	React.useEffect(() => {
		if (props.location.message) {
			enqueueSnackbar(props.location.message.text, {
				content: (key, message) => <SnackMessage id={key} message={message} color={props.location.message.color || 'danger'} />,
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const classes = useStyles();
	const [loginEmail, setloginEmail] = React.useState('');
	const [loginEmailState, setloginEmailState] = React.useState('');
	const [loginPassword, setloginPassword] = React.useState('');
	const [loginPasswordState, setloginPasswordState] = React.useState('');
	const { enqueueSnackbar } = useSnackbar();
	const history = useHistory();
	const login = async (event) => {
		event.preventDefault();

		if (loginEmailState === '') {
			setloginEmailState('error');
		}
		if (loginPasswordState === '') {
			setloginPasswordState('error');
		}

		if (loginEmail && loginPassword) {
			try {
				const response = await AuthService.login(loginEmail, loginPassword);

				if (response.accessToken) {
					store.dispatch(setAuthActionCreator(response));
					store.dispatch(setLockedActionCreator(false));
					history.push(`/${layoutNames.portal}/contact-centers`);
				}
			} catch (error) {
				if (error.errorCode === 'PASSWORD_EXPIRED') {
					history.push({
						pathname: `/${layoutNames.auth}/change-password`,
						state: {
							username: loginEmail,
						}
					});
				}

				enqueueSnackbar(error.resolvedErrorMessage, {
					content: (key, message) => <SnackMessage id={key} message={message} color='danger' />,
				});
			}
		}
	};

	const toSelfPasswordResetPage = () => {
		console.log('{LoginPage} - toSelfPasswordResetPage invoked');
		history.push(`/${layoutNames.auth}/user-password-reset`);
	}

	return (
		<div className={classes.container}>
			<GridContainer justify='center'>
				<GridItem xs={12} sm={6} md={4}>
					<form onSubmit={login}>
						<Card login className={classes[cardAnimaton]}>
							<CardHeader
								color='rose'
								className={`${classes.inlineBlock} ${classes.textCenter}`}
							>
								<h4 className={classes.inlineBlock}>Log In to Sevis</h4>
							</CardHeader>
							<CardBody>
								<CustomInput
									success={loginEmailState === 'success'}
									error={loginEmailState === 'error'}
									labelText='Username or Email *'
									id='loginemail'
									formControlProps={{
										fullWidth: true
									}}
									inputProps={{
										type: 'text'
									}}
									onChange={event => {
										if (verifyLength(event.target.value, 1)) {
											setloginEmailState('inactive');
										} else {
											setloginEmailState('error');
										}
										setloginEmail(event.target.value);
									}}
								/>
								<CustomInput
									success={loginPasswordState === 'success'}
									error={loginPasswordState === 'error'}
									labelText='Password *'
									id='loginpassword'
									formControlProps={{
										fullWidth: true
									}}
									inputProps={{
										type: 'password',
										autoComplete: 'off'
									}}
									onChange={event => {
										if (verifyLength(event.target.value, 1)) {
											setloginPasswordState('inactive');
										} else {
											setloginPasswordState('error');
										}

										setloginPassword(event.target.value);
									}}
								/>
								<PasswordResetButton onClick={toSelfPasswordResetPage}>Forgot Password?</PasswordResetButton>
							</CardBody>
							<CardFooter className={classes.justifyContentCenter}>
								<Button color='rose' simple size='lg' block type='submit'>
									LOG IN
                </Button>
							</CardFooter>
						</Card>
					</form>
				</GridItem>
			</GridContainer>
		</div>
	);
}
